import React, { useCallback } from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './TempDomainModal.styles';
import { useHistory } from 'react-router';
import useLocale from '@/hooks/useLocale';
import { useDispatch, useSelector } from 'react-redux';
import { commonActions, preChatActions } from '@/redux/modules';

const TempDomainModal = ({
  temporaryDomainModal,
  optionLabel = 'optionLabel',
  setTemporaryDomainModal,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { routes: routesLocale, changeDomain: changeDomainLocale } = useLocale();
  const sitesReducer = useSelector(state => state.sites);

  const handleClose = useCallback(() => {
    setTemporaryDomainModal([]);
  }, [setTemporaryDomainModal]);


  const openSupportTab = useCallback(() => {
    dispatch(preChatActions.preChat.setShowPreChat(true));
    dispatch(commonActions.notifications.clearAll());
  }, [dispatch]);

  const redirectToChangeDomainHandler = useCallback(({ domain, hostingId }) => {
    const currentDomain = sitesReducer.list && sitesReducer.list.find(item => item.hosting_id === Number(hostingId));
    const cpanelDomains = currentDomain && currentDomain.cpanel_domains;

    if (!cpanelDomains) {
      dispatch(commonActions.notifications.set({
        toast: {
          title: changeDomainLocale.changeDomainErrorMessage.title,
          info: (
            <Styles.SnackbarMessage>
              {changeDomainLocale.changeDomainErrorMessage.description(openSupportTab)}
            </Styles.SnackbarMessage>
          ),
          context: 'negative',
        },
      }));
      return;
    }
    history.push(`${routesLocale.sitesPage}${routesLocale.changeDomain}/${hostingId}/${domain}`);
  }, [
    history,
    routesLocale.changeDomain,
    routesLocale.sitesPage,
    changeDomainLocale.changeDomainErrorMessage,
    openSupportTab,
    dispatch,
    sitesReducer.list,
  ]);

  return (
    <Modal
      open
      onClose={handleClose}
      title={changeDomainLocale.tempDomainModalBeforeEmail.title}
    >
      <Styles.TempMailContentWrapper>
        <Styles.TempMailContent>
          {changeDomainLocale.tempDomainModalBeforeEmail.content(optionLabel)}
        </Styles.TempMailContent>

        <Styles.TempDomainList>
          {temporaryDomainModal.map(item => (
            <Styles.TempDomainListItem key={`${item.hosting_id}-${item.domain}`}>
              <Styles.DomainName>
                {item.domain}
              </Styles.DomainName>


              <Button
                testId={`changeDomain-${item.hosting_id}`}
                size="small"
                variant="text"
                label={changeDomainLocale.tempDomainModalBeforeEmail.changeDomainLabel}
                onClick={() => redirectToChangeDomainHandler({
                  domain: item.domain,
                  hostingId: item.hosting_id,
                })}
              />
            </Styles.TempDomainListItem>
          ))}
        </Styles.TempDomainList>

        <Styles.TempMailContent>
          {changeDomainLocale.tempDomainModalBeforeEmail.contentAfterList}
        </Styles.TempMailContent>


        <Styles.ActionsWrapper>
          <Button
            testId="backButton"
            variant="secondary"
            label={changeDomainLocale.tempDomainModalBeforeEmail.backLabel}
            onClick={handleClose}
          />
        </Styles.ActionsWrapper>
      </Styles.TempMailContentWrapper>
    </Modal>
  );
};

export default TempDomainModal;
